import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ tag, title, sub, center = false }) => (
  <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <div className={`flex items-center gap-3 ${center ? "justify-center" : ""}`}>
      <span className="h-px w-8 bg-neon/70" />
      <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-neon">{tag}</span>
    </div>
    <h2 className="mt-4 font-display text-3xl font-extrabold uppercase leading-[0.95] tracking-tight sm:text-4xl lg:text-5xl">
      {title}
    </h2>
    {sub && <p className="mt-4 max-w-2xl text-sm leading-relaxed text-slate-400 sm:text-base">{sub}</p>}
  </Reveal>
);
